export default __webpack_public_path__ + "static/ewallet-fuel-solutions-707d03f88f2332c8f6a0a4fd8dd34dcb.png";